<div class="container">
  <div class="row mt-5">
    <div class="col-12">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_245_1774)">
          <path d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z" fill="#009DFF" />
        </g>
        <defs>
          <clipPath id="clip0_245_1774">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <label class="back" routerLink="/office/{{ details?.practiceId }}">Back</label>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12">
      <label class="main-header-text">Exclusive Dental Plan Savings - </label>
      <label class="plan-name-header-text mx-2"> {{ eventsManager.selectedLevel.planName }}</label>
    </div>
  </div>

  <app-plan-summary [planSummary]="details?.salesPlanMarketingDetails?.planSummary" [coverageLevel]="coverageLevel"> </app-plan-summary>

  <app-plan-benefits [planBenefits]="details?.salesPlanMarketingDetails?.planBenefits || null" [ancillaryCodes]="template?.ancillaryBenefits || ''"> </app-plan-benefits>

  <app-common-dental-savings [commonDentalPlanSavings]="details?.salesPlanMarketingDetails?.commonDentalPlanSavings || null"></app-common-dental-savings>

  <app-additional-member-savings [coverageLevel]="coverageLevel"></app-additional-member-savings>

  <app-exclusions
    [details]="details">
  </app-exclusions>
</div>

<app-plan-disclosure
  [officeData]="officeData"
  [templateId]="template?.benefitPlanTemplateId"
  [type]="PlanViewType.Detail"
  [coverageLevelId]="coverageLevel?.benefitPlanCoverageLevelId ?? undefined">
</app-plan-disclosure>
